
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import blogimage from "../../../../assets/images/realestateblogimage.png";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import askimg from "../../../../assets/homeimages/askbtn.svg";
import bulbinvestment from "../../../../assets/images/bulbinvestment.png";
import { Trans, useTranslation } from "react-i18next";
import headingback from "../../../../assets/images/investmentblogbackthree.png";
import investmenticon from "../../../../assets/askTheExpertImages/investmentmenuicon.svg"
import React, { useEffect } from 'react';

import './articleDetails.css'; 
import { decodeHtmlEntities } from "../../../../shared/helper";

const InvestmentArticleDetailsJsx = (props) => {
  const {
    detailsData
  } = props;

  const { t } = useTranslation();
  useEffect(() => {
  }, []);

  

  return (
    <>

<section className="investmentblogdetails">
      <div className="container">
        <div className="blogsectionone">
          <div className="row">
          <div className="col-lg-5 col-sm-5"> 
          <div className="blogsectiononeimage"><img src={blogimage} alt="blogimage"/><div className="tagreal"><span><img src={investmenticon} alt="investment Icon"/></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div></div>
            <div className="d-block d-lg-none d-sm-none d-md-none mtminuspop blogsectioleft">
            <div className="title">
          <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
          <div className="d-flex userdetails">
          <div className="userphoto">
            <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
          </div>
          <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
        </div>
            </div> 
         </div>
          <div className="col-lg-7 col-sm-7"> 
          <div className="blogsectiononecaption">
          <div className="blogsectioleft">
        <div className="title d-none d-sm-block">
          <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
          <p>{detailsData?.acf?.banner_sectionn?.short_description}</p>
          <div className="d-none d-sm-block">
          <div className="d-flex userdetails">
          <div className="userphoto">
            <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
          </div>
          <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
        </div>
</div>
        </div>
        
          </div>
          </div>
          </div>
        </div>
        <div className="blogsectiontwo">
          <div className="row">
            <div className="col-lg-5 col-sm-5">
            <div className="blogsectiontwolefttext">
              <h2>{detailsData?.acf?.info_section?.left_section?.title}</h2>
              <p>{detailsData?.acf?.info_section?.left_section?.description}</p>
            </div>
            </div>
            <div className="col-lg-7 col-sm-7">
            <div className="blogsectiontwoleftright">
              <h2>{detailsData?.acf?.info_section?.right_section?.title}</h2>
              <p>{detailsData?.acf?.info_section?.right_section?.description}</p>
            </div>
            </div>
          </div>
        </div>
        <div className="blogsectionthree">
          <div className="heading">
            <div className="d-block d-lg-none d-sm-none d-md-none "><img src={headingback} alt="headingback"/></div>
            <h2>{detailsData?.acf?.info_block?.title}</h2></div>
          <div className="row">

          <div className="col">
            <div className="blogsectionthreeinner">
            <div className="blogsectionthreeinnerimg"><img src={detailsData?.acf?.info_block?.info_block_1?.image} alt="blogimage"/> 
            <div className="heading">{detailsData?.acf?.info_block?.info_block_1?.title}</div></div>
            <div className="blogsectionthreeinnertext"><span>1</span><p>{detailsData?.acf?.info_block?.info_block_1?.description}</p></div>
            </div>
          </div>

          <div className="col">
            <div className="blogsectionthreeinner">
            <div className="blogsectionthreeinnerimg"><img src={detailsData?.acf?.info_block?.info_block_2?.image} alt="blogimage"/> 
            <div className="heading">{detailsData?.acf?.info_block?.info_block_2?.title}</div></div>
            <div className="blogsectionthreeinnertext"><span>2</span><p>{detailsData?.acf?.info_block?.info_block_2?.description}</p></div>
            </div>
          </div>

          <div className="col">
            <div className="blogsectionthreeinner">
            <div className="blogsectionthreeinnerimg"><img src={detailsData?.acf?.info_block?.info_block_3?.image} alt="blogimage"/> 
            <div className="heading">{detailsData?.acf?.info_block?.info_block_3?.title}</div></div>
            <div className="blogsectionthreeinnertext"><span>3</span><p>{detailsData?.acf?.info_block?.info_block_3?.description}</p></div>
            </div>
          </div>

          <div className="col">
            <div className="blogsectionthreeinner">
            <div className="blogsectionthreeinnerimg"><img src={detailsData?.acf?.info_block?.info_block_4?.image} alt="blogimage"/> 
            <div className="heading">{detailsData?.acf?.info_block?.info_block_4?.title}</div></div>
            <div className="blogsectionthreeinnertext"><span>4</span><p>{detailsData?.acf?.info_block?.info_block_4?.description}</p></div>
            </div>
          </div>

          <div className="col">
            <div className="blogsectionthreeinner">
            <div className="blogsectionthreeinnerimg"><img src={detailsData?.acf?.info_block?.info_block_5?.image} alt="blogimage"/> 
            <div className="heading">{detailsData?.acf?.info_block?.info_block_5?.title}</div></div>
            <div className="blogsectionthreeinnertext"><span>5</span><p>{detailsData?.acf?.info_block?.info_block_5?.description}</p></div>
            </div>
          </div>



          </div>
        </div>
      
        <div className="blogsectionfour">
          <h2>{detailsData?.acf?.statistical_overview?.title}</h2>
          <ul className="staticdata">
            <li>{detailsData?.acf?.statistical_overview?.info_block_1?.description}</li>
            <li>{detailsData?.acf?.statistical_overview?.info_block_2?.description}</li>
            <li>{detailsData?.acf?.statistical_overview?.info_block_3?.description}</li>
            <li>{detailsData?.acf?.statistical_overview?.info_block_4?.description}</li>
          </ul>
        </div>
        <div className="blogsectionfive">
          <h2>{detailsData?.acf?.red_flags?.title}</h2>
          <div className="blogflag" dangerouslySetInnerHTML={{ __html: detailsData?.acf?.red_flags?.description }}>            
          </div>
        </div>
    
       
        <div className="blogsectionsix">
          <div className="row">
            <div className="col-lg-3 col-sm-3 blogsectionsixleftouter" >
              <div className="blogsectionsixleft">
                <h2>{detailsData?.acf?.description_section?.title}</h2>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 padleftfifty">
            <div className="blogsectionsixmiddle"  dangerouslySetInnerHTML={{ __html: detailsData?.acf?.description_section?.description }} >              
            </div>
            </div>
            <div className="col-lg-3 col-sm-3 blogsectionsixrightouter">
            <div className="blogsectionsixright">
            <div className="blogsectionsixrighttop"><img src={detailsData?.acf?.description_section?.image} alt="blogimage" /></div>
            <div className="blogsectionsixrightbottom"><img src={detailsData?.acf?.description_section?.image_2} alt="blogimage" /></div>
            </div>
            </div>
          </div>
        </div>
        
        
        <div className="blogsectionseven">
          <h2>Conclusion</h2>
          <ul className="conclusioninner">
            <li>
              <span>{detailsData?.acf?.conclusion_section?.info_block_1?.title}</span>
              <p>{detailsData?.acf?.conclusion_section?.info_block_1?.description}</p>
            </li>
            <li>
              <span>{detailsData?.acf?.conclusion_section?.info_block_2?.title}</span>
              <p>{detailsData?.acf?.conclusion_section?.info_block_2?.description}</p>
            </li>
            <li>
              <span>{detailsData?.acf?.conclusion_section?.info_block_3?.title}</span>
              <p>{detailsData?.acf?.conclusion_section?.info_block_3?.description}</p>
            </li>
          </ul>
        </div>
        <div className="blogaskexpert">
            <div className="row">
              <div className="col-lg-7 d-flex  align-items-center">
                <span><img src={bulbinvestment} alt="bulb" /></span>
                <h3><Trans i18nKey={t("COMMON.BLOGTAGONE")}></Trans>
              </h3>
              </div>
              <div className="col-lg-5 d-flex justify-content-end">
              <Link to={'/AskTheExpert'}>
                            <div className={`askbutton`}>
                                <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                                <img src={askimg} alt="Ask now" />
                            </div>
                        </Link>              </div>
            </div>
          </div>
      </div>
      </section>

    </>

  );
};

export default InvestmentArticleDetailsJsx;